"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _portalHealthStates = _interopRequireDefault(require("EmailData/constants/portalHealthStates"));

var _portalSuspension = require("EmailData/constants/portalSuspension");

var _HEALTH_STATES_SEVERI;

var HEALTH_STATES_SEVERITY = (_HEALTH_STATES_SEVERI = {}, (0, _defineProperty2.default)(_HEALTH_STATES_SEVERI, _portalHealthStates.default.DEFAULT, 0), (0, _defineProperty2.default)(_HEALTH_STATES_SEVERI, _portalHealthStates.default.PROBATION_1, 10), (0, _defineProperty2.default)(_HEALTH_STATES_SEVERI, _portalHealthStates.default.PROBATION_2, 20), (0, _defineProperty2.default)(_HEALTH_STATES_SEVERI, _portalHealthStates.default.PROBATION_3, 30), (0, _defineProperty2.default)(_HEALTH_STATES_SEVERI, _portalHealthStates.default.SUSPENDED, 40), _HEALTH_STATES_SEVERI);
var defaults = {
  appealId: null,
  appealState: null,
  overallState: _portalHealthStates.default.DEFAULT,
  show: false,
  reason: _portalSuspension.SUSPENSION_REASON_TYPES.DEFAULT
};

function getHealthSeverity(state) {
  return HEALTH_STATES_SEVERITY[state];
}

var PortalHealthStatus =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(PortalHealthStatus, _Record);

  function PortalHealthStatus() {
    (0, _classCallCheck2.default)(this, PortalHealthStatus);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PortalHealthStatus).apply(this, arguments));
  }

  (0, _createClass2.default)(PortalHealthStatus, [{
    key: "isHealthy",
    value: function isHealthy() {
      return this.overallState === _portalHealthStates.default.DEFAULT;
    }
  }, {
    key: "isInProbation1",
    value: function isInProbation1() {
      return this.overallState === _portalHealthStates.default.PROBATION_1;
    }
  }, {
    key: "isInProbation2",
    value: function isInProbation2() {
      return this.overallState === _portalHealthStates.default.PROBATION_2;
    }
  }, {
    key: "isInPreSuspension",
    value: function isInPreSuspension() {
      return this.overallState === _portalHealthStates.default.PROBATION_3;
    }
  }, {
    key: "isSuspended",
    value: function isSuspended() {
      return this.overallState === _portalHealthStates.default.SUSPENDED;
    }
  }, {
    key: "isForcedSuspension",
    value: function isForcedSuspension() {
      return this.isSuspended() && (this.reason === _portalSuspension.SUSPENSION_REASON_TYPES.OVERRIDE || this.reason === _portalSuspension.SUSPENSION_REASON_TYPES.EHAWK);
    }
  }, {
    key: "isEhawkSuspension",
    value: function isEhawkSuspension() {
      return this.reason === _portalSuspension.SUSPENSION_REASON_TYPES.EHAWK;
    }
  }, {
    key: "getAppealId",
    value: function getAppealId() {
      return this.appealId;
    }
  }, {
    key: "getAppealState",
    value: function getAppealState() {
      return this.appealState;
    }
  }, {
    key: "getCurrentSeverityLevel",
    value: function getCurrentSeverityLevel() {
      return getHealthSeverity(this.overallState);
    }
  }, {
    key: "getCurrentState",
    value: function getCurrentState() {
      return this.overallState;
    }
  }, {
    key: "getReason",
    value: function getReason() {
      return this.reason;
    }
  }, {
    key: "hasDescalated",
    value: function hasDescalated(portalDismissStatus) {
      var previousState = portalDismissStatus.level;
      var currentState = this.getCurrentState();
      return PortalHealthStatus.warnLevelDecreased(previousState, currentState);
    }
  }, {
    key: "shouldShowMessage",
    value: function shouldShowMessage(portalDismissStatus) {
      var hasDescalated = this.hasDescalated(portalDismissStatus);
      var previousDismissed = portalDismissStatus.dismissed;
      return this.show && !hasDescalated && !previousDismissed;
    }
  }], [{
    key: "from",
    value: function from(json) {
      if (json.status) {
        json.status.appealId = json.appealReference;
        json.status.appealState = json.appealState;
      }

      return new PortalHealthStatus(json.status);
    }
  }, {
    key: "warnLevelDecreased",
    value: function warnLevelDecreased(previous, current) {
      var prevLevel = getHealthSeverity(previous);
      var currentLevel = getHealthSeverity(current);
      return currentLevel < prevLevel;
    }
  }]);
  return PortalHealthStatus;
}((0, _immutable.Record)(defaults));

PortalHealthStatus.REASON_TYPES = _portalSuspension.SUSPENSION_REASON_TYPES;
PortalHealthStatus.HEALTH_STATES = _portalHealthStates.default;
var _default = PortalHealthStatus;
exports.default = _default;
module.exports = exports.default;